import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import { fsfn_sports } from 'projectSpecific/sports/functions/fbSportsFuntions'
import React, { useContext, useMemo, useState } from 'react'
import { _fetchModes, _mediaModes, _rightModes_mdu } from './MatchDataUpdate'
import { _sdm } from '../dashboard/SportsDashboard'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { _sportCollections } from 'projectSpecific/sports/cnr/reducers/SportsSidebarReducer'
import useGoogleSports from 'projectSpecific/sports/useHelpers/useGoogleSports'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useMatches } from 'react-router-dom'

const _openModes = {
  database: 'database',
  realtimeDb: 'realtimeDb',
  googleSheets: 'googleSheets',
  media: 'media',
}

const useMediaDataOptions = ({
  currentMenuKey,
  handleMode_left,
  linkValues,
  mediaUrl,
  setMode_right,
  sportsData_handlers,
  sportsDataMode,
}) => {


  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const {
    gameScoringType,
    currentSeason_info,
    sportSettings_info,
  } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const [mediaResults, set_mediaResults] = useState()
  const [fetching, setFetching] = useState()

  const { handleGet_gsMatches } = useGoogleSports({
    currentMenuKey,
    gameScoringType,
    sportsDataMode,
  })

  const handleGoogleSearch = (e, opts) => {
    setFetching(true)
    handleMode_left(e)
    const cb = (matchResultsInfo) => {
      const _forPlayoffs = opts?.fetchMode === 'playoffResults'
      console.log('matchResultsInfo', matchResultsInfo)
      set_mediaResults({ matchResultsInfo, _forPlayoffs })
      setFetching(false)
      // sportsData_handlers.handleAmmend_gsMatches(matchResultsInfo, _forPlayoffs)
    }
    // sportsData_handlers.handleStartUpdate()
    handleGet_gsMatches({ opts, callback: cb })
  }

  const handleAmmend = (e, opts) => {
    e && e.stopPropagation()
    const updatedMatches = _.chain(matches_flat_filtered)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
    const updatedMatches_gs = _.chain(matches_gs)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
  }

  const handleTestFunction = (e) => {
    e && e.stopPropagation()
    const cb = (res) => {
      console.log('res', res)
    }
    const data = {
      pojoOnly: false,
      testingOnly: true,
      glsOnly: false,
    }
    fsfn_sports.getSportsDataGlsScores(data, cb)
  }

  const handleGoogleSearch_rankings = (e) => {
    handleMode_left(e)
    const gsValues = _.clone(linkValues)
    gsValues.googleSheetsId = linkValues.rankingsGoogleSheetsId
    gsValues.sheetName = linkValues.rankingsSheet
    if (sportsData_handlers) {
      sportsData_handlers.handleStartUpdate()
      sportsData_handlers.handleGet_gsRankings(gsValues, currentYear, sportsKey)
    }
  }

  const btn_itemRight = (items, icon_sub, caption, rightMode, disabled, fl) => {
    const occ = (a, b) => {
      const rm = b?.rightMode ? b?.rightMode : a?.rightMode
      setMode_right(rm)
    }
    items.push({ caption, oc: occ, color: 'blue', icon: icon_sub, disabled, opts: { rightMode: rightMode } })
  }

  const item_itemOpen = (items, icon_sub, openMode, disabled) => {
    const occ = (e, opts) => {
      handleMode_left(e)
      switch (opts.openMode) {
        case _openModes.database:
          // pks_matches_seasonal
          openExternal.firebaseDbDirect(pathViews, [_sportCollections._matches_seasonal])
          break;
        case _openModes.realtimeDb:
          openExternal.realtimeDb(pathViews)
          break;
        case _openModes.googleSheets:
          openExternal.googleSheets(linkValues.googleSheetsId)
          break;
        case _openModes.media:
          window.open(mediaUrl, '_blank')
          break;
      }
    }
    items.push({ caption: _.startCase(openMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { openMode: openMode } })
  }

  const item_itemSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleGoogleSearch(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const item_itemMediaSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleMediaSearch_results(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const items_ammend = () => {
    const items = []
    // items.push({ header: 'Adjust', db: true, da: true, icon: 'refresh', })
    items.push({ caption: 'Revert to Old Date', oc: handleAmmend, color: 'teal', fl: true, opts: { rightMode: _rightModes_mdu.exportResults } })
    return items
  }

  const items_scores = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Scores (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Update Scores', _rightModes_mdu.confirmScores)
    items.push({ caption: 'Test Functions', oc: handleTestFunction, color: 'teal', fl: true, icon: 'arrow right' })
    return items
  }

  const items_backup = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Backup (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Backup Matches', _rightModes_mdu.backupMatches)
    btn_itemRight(items, icon_sub, 'Backup Playoff Matches', _rightModes_mdu.backupPlayoffMatches)
    btn_itemRight(items, icon_sub, 'Backup Scores', _rightModes_mdu.backupScores)
    return items
  }

  /**
   * 
   * @returns a list of items that will appear within a menu
   */
  const items_search = () => {

    const items = []
    const items_external = []
    const items_s = []
    const items_media = []

    let icon_ext;
    let icon_search;

    switch (sportsDataMode) {
      case _sdm.sports.seasonResults:
        icon_ext = 'external alternate'
        item_itemOpen(items_external, icon_ext, _openModes.database)
        item_itemOpen(items_external, icon_ext, _openModes.realtimeDb)
        item_itemOpen(items_external, icon_ext, _openModes.googleSheets)
        item_itemOpen(items_external, icon_ext, _openModes.media)

        if (linkValues.scoresSheet) {
          icon_search = 'search'
          item_itemSearch(items_s, icon_search, _fetchModes.results)
          item_itemSearch(items_s, icon_search, _fetchModes.playoffResults)
          item_itemSearch(items_s, icon_search, _fetchModes.resultsMedia)
          item_itemSearch(items_s, icon_search, _fetchModes.playoffResultsMedia)
          item_itemSearch(items_s, icon_search, _fetchModes.wpialResults)
        }

        if (mediaUrl || 1 === 1) {
          item_itemMediaSearch(items_media, icon_search, _mediaModes.results)
          item_itemMediaSearch(items_media, icon_search, _mediaModes.playoffResults)
          // items.push({ caption: 'Date Results', oc: handleMediaSearch_dates, color: 'blue', fl: true })
          // items.push({ caption: 'Playoff Results', oc: handleMediaSearch_playoffs, color: 'blue', fl: true, icon: 'search' })
          // items.push({ caption: 'Refresh Playoff Results', oc: handleRefreshSearch_playoffs, color: 'blue', fl: true })
        }
        break;

      case _sdm.sports.seasonRankings:
        items.push({ caption: 'Search Google Sheets Rankings', oc: handleGoogleSearch_rankings, color: 'blue', icon: 'search', fl: true })
      // items.push({ caption: 'Open Google Sheets', oc: handleOpenGoogleSheets, color: 'orange', icon: appIconTypes.externalAlternate, fl: true })

      default:
        break;

      // nothing
    }
    return { items_external, items_s, items_media }
  }

  const items_exportTo = () => {
    const items = []
    let icon_sub = 'cloud upload';
    btn_itemRight(items, icon_sub, 'Results', _rightModes_mdu.exportResults)
    btn_itemRight(items, icon_sub, 'Playoff Results', _rightModes_mdu.exportPlayoffResults)
    btn_itemRight(items, icon_sub, 'Media Results', _rightModes_mdu.exportResultsMedia)
    btn_itemRight(items, icon_sub, 'Media Playoff Results', _rightModes_mdu.exportPlayoffResultsMedia)
    btn_itemRight(items, icon_sub, 'Standings', _rightModes_mdu.exportStandings)
    return items
  }

  const matchDataOptions = useMemo(() => {
    const { items_external, items_s, items_media } = items_search()
    const allItems = {
      search: { items: items_s, caption: 'Search', icon: 'search', iconColor: 'yellow' },
      media: { items: items_media, caption: 'Media', icon: 'newspaper outline', iconColor: 'purple' },
      export: { items: items_exportTo(), caption: 'Export', icon: 'cloud download', iconColor: 'pink' },
      ammend: { items: items_ammend(), caption: 'Ammend', icon: 'edit outline', iconColor: 'blue' },
      scores: { items: items_scores(), caption: 'Scores', icon: 'list ol', iconColor: 'black' },
      openExternal: { items: items_external, caption: 'External', icon: 'external alternate', iconColor: 'orange' },
      backup: { items: items_backup(), caption: 'Backup', icon: 'database', iconColor: 'teal' },
    }
    return allItems
  })

  return { matchDataOptions, mediaResults, fetching }
}

export default useMediaDataOptions